<section class="mb-6">
  <div
    class="relative flex items-center justify-center w-full aspect-[16/9] bg-gray-200">
    <app-video-shot-asset [clip]="clip" [resourceProps]="{ controls: true }" />
  </div>
</section>
<section class="space-y-8">
  <p-slider
    [ngModel]="range"
    (ngModelChange)="onRangeChange($event)"
    [range]="true"
    [min]="0"
    [max]="100"
    [step]="0.1"
    styleClass="w-full"></p-slider>
  <div class="flex items-center space-x-8">
    <div class="grow">
      <p-floatlabel variant="in">
        <p-inputmask
          inputId="start_at"
          styleClass="w-full"
          mask="99:99:999"
          [(ngModel)]="startAt" />
        <label for="start_at">Start Time</label>
      </p-floatlabel>
    </div>
    <div class="grow">
      <p-floatlabel variant="in">
        <p-inputmask
          inputId="end_at"
          styleClass="w-full"
          mask="99:99:999"
          [(ngModel)]="endAt" />
        <label for="end_at">End Time</label>
      </p-floatlabel>
    </div>
  </div>
</section>
